import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Edit from './Edit';
import New from './New';

function DocumentScreen() {
  const { id: documentId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  if (documentId === 'new') {
    // TODO: Check if options.format is a valid DocumentFormat value.
    // If not, default to DocumentFormat.BOOKLET.
    return (
      <New />
    );
  }

  if (location.pathname === '/try-it') {
    return (
      <Edit
        documentId="try-it"
        isPublishedView={location.pathname.startsWith('/publish/')}
      />
    );
  }

  if (documentId) {
    return (
      <Edit
        documentId={documentId}
        isPublishedView={location.pathname.startsWith('/publish/')}
      />
    );
  }

  navigate('/gallery');
  return null;
}

export default DocumentScreen;
